"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _styles = require("@material-ui/core/styles");

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _PhotoUpload = _interopRequireDefault(require("../PhotoUpload"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var countCharacters = function countCharacters(characters) {
  return !characters ? 0 : characters.replace(/\D/g, "").length;
};

var PhoneFormatCustom = function PhoneFormatCustom(props) {
  var inputRef = props.inputRef,
      other = _objectWithoutProperties(props, ["inputRef"]);

  return /*#__PURE__*/_react["default"].createElement(_reactTextMask["default"], _extends({}, other, {
    ref: function ref(_ref) {
      inputRef(_ref ? _ref.inputElement : null);
    },
    mask: function mask(rawValue) {
      return !countCharacters(rawValue) ? [] : countCharacters(rawValue) <= 11 ? ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : countCharacters(rawValue) === 12 ? ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    },
    placeholderChar: "\u2000",
    placeholder: "(555) 555-5555",
    showMask: true,
    guide: true,
    autoComplete: "new-password"
  }));
};

var NumberFormatCustom = function NumberFormatCustom(_ref2) {
  var inputRef = _ref2.inputRef,
      onChange = _ref2.onChange,
      other = _objectWithoutProperties(_ref2, ["inputRef", "onChange"]);

  return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat["default"], _extends({}, other, {
    fixedDecimalScale: true,
    decimalScale: 2,
    getInputRef: inputRef,
    onValueChange: function onValueChange(values) {
      onChange({
        target: {
          value: values.value
        }
      });
    },
    thousandSeparator: true,
    prefix: "$"
  }));
};

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    progress: {
      margin: theme.spacing(2)
    },
    root: {
      minWidth: "332px"
    },
    buttonsContainer: {
      marginTop: theme.spacing(4)
    }
  };
});

var _default = function _default(_ref3) {
  var _ref3$data = _ref3.data,
      data = _ref3$data === void 0 ? {} : _ref3$data,
      _ref3$onChange = _ref3.onChange,
      onChange = _ref3$onChange === void 0 ? function (data) {
    return null;
  } : _ref3$onChange,
      _ref3$onSubmit = _ref3.onSubmit,
      onSubmit = _ref3$onSubmit === void 0 ? function (data) {
    return null;
  } : _ref3$onSubmit,
      _ref3$buttonLabel = _ref3.buttonLabel,
      buttonLabel = _ref3$buttonLabel === void 0 ? "Submit" : _ref3$buttonLabel,
      _ref3$fields = _ref3.fields,
      fields = _ref3$fields === void 0 ? {} : _ref3$fields,
      _ref3$submitting = _ref3.submitting,
      submitting = _ref3$submitting === void 0 ? false : _ref3$submitting,
      _ref3$primaryButtonPr = _ref3.primaryButtonProps,
      primaryButtonProps = _ref3$primaryButtonPr === void 0 ? {} : _ref3$primaryButtonPr,
      errorMessage = _ref3.errorMessage,
      _ref3$onValidChange = _ref3.onValidChange,
      onValidChange = _ref3$onValidChange === void 0 ? function () {
    return null;
  } : _ref3$onValidChange,
      _ref3$excludeButton = _ref3.excludeButton,
      excludeButton = _ref3$excludeButton === void 0 ? false : _ref3$excludeButton,
      _ref3$extraIsValid = _ref3.extraIsValid,
      extraIsValid = _ref3$extraIsValid === void 0 ? true : _ref3$extraIsValid,
      _ref3$NestedForm = _ref3.NestedForm,
      NestedForm = _ref3$NestedForm === void 0 ? null : _ref3$NestedForm,
      _ref3$isNested = _ref3.isNested,
      isNested = _ref3$isNested === void 0 ? false : _ref3$isNested;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isValid = _useState2[0],
      setIsValid = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      dirties = _useState4[0],
      setDirties = _useState4[1];

  var handleChange = function handleChange(field, _ref4) {
    var _ref4$target = _ref4.target,
        value = _ref4$target.value,
        checked = _ref4$target.checked;
    return [onChange(field, value), setDirties([].concat(_toConsumableArray(dirties), [field]))];
  };

  (0, _react.useEffect)(function () {
    // console.log("Let's see", !!extraIsValid, Object.entries(fields).every(([key, value]) => 
    // !!value.customValidator ? (
    //    !!value.customValidator(data[key])
    // ) : !!value.required ? (
    //   !!data[key] && value.regex.test(data[key]) 
    // ) : (
    //   !data[key] ? true : value.regex.test(data[key]))
    // ))
    setIsValid(!!extraIsValid && Object.entries(fields).every(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];

      return !!value.customValidator ? !!value.customValidator(data[key]) : !!value.required ? !!data[key] && value.regex.test(data[key]) : !data[key] ? true : value.regex.test(data[key]);
    }));
  }, [Object.values(data).join(""), Object.values(fields).length, extraIsValid]);
  (0, _react.useEffect)(function () {
    onValidChange(isValid);
  }, [isValid]);
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    component: !!isNested ? 'div' : "form",
    className: classes.container,
    noValidate: true,
    autoComplete: "off"
  }, Object.entries(fields).map(function (_ref7, i) {
    var _ref8 = _slicedToArray(_ref7, 2),
        key = _ref8[0],
        value = _ref8[1];

    return /*#__PURE__*/_react["default"].createElement(_core.Box, {
      key: i,
      hidden: value.type === 'hidden'
    }, value.type === 'media' ? /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
      key: i,
      fullWidth: true
    }, /*#__PURE__*/_react["default"].createElement(_PhotoUpload["default"], {
      onUpload: function onUpload(photoUrl) {
        return handleChange(key, {
          target: {
            value: photoUrl
          }
        });
      },
      photoUrl: !!value.value ? value.value(data[key] || "") : data[key] || ""
    }), /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], {
      component: 'div'
    }, dirties.includes(key) && !fields[key].regex.test(data[key]) ? value.errorMessage || "" : value.helperText || "")) : value.type === 'checkbox' ? /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
      variant: "outlined",
      key: i,
      fullWidth: true
    }, /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
      variant: "outlined",
      htmlFor: "my-input"
    }, value.label), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
      control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        checked: !!value.value ? !!value.value(data[key] || "") : !!(data[key] === null || data[key] === undefined ? "" : data[key]),
        onChange: function onChange(_ref9) {
          var _ref9$target = _ref9.target,
              checked = _ref9$target.checked,
              value = _ref9$target.value;
          return handleChange(key, {
            target: {
              value: checked ? value : null
            }
          });
        },
        value: new Date().toISOString()
      }),
      label: /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "caption"
      }, value.checkboxLabel)
    }), /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], {
      component: 'div'
    }, dirties.includes(key) && !fields[key].regex.test(data[key]) ? value.errorMessage || "" : value.helperText || "")) : /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
      autoComplete: value.type === 'password' ? "new-password" : "true",
      variant: "outlined",
      autoFocus: !!value.autoFocus,
      multiline: !!fields[key].rows,
      rows: fields[key].rows,
      key: i,
      error: !data[key] && !value.required ? false : !dirties.includes(key) ? false : !!value.customValidator ? !value.customValidator(data[key]) : !fields[key].regex.test(data[key]),
      required: value.required,
      disabled: value.disabled,
      helperText: (!data[key] && !value.required ? false : !dirties.includes(key) ? false : !!value.customValidator ? !value.customValidator(data[key]) : !fields[key].regex.test(data[key])) ? value.errorMessage || "" : value.helperText || "",
      onChange: handleChange.bind(null, key),
      label: value.label,
      value: !!value.value ? value.value(data[key] || "") : data[key] === null || data[key] === undefined ? "" : data[key],
      placeholder: value.placeholder || "",
      type: value.type === "money" ? 'text' : value.type || "text",
      margin: "normal",
      fullWidth: true,
      select: !!value.options,
      InputLabelProps: {
        shrink: true
      },
      InputProps: value.type === 'money' ? {
        inputComponent: NumberFormatCustom
      } : value.type === 'phone' ? {
        inputComponent: PhoneFormatCustom
      } : {}
    }, (value.options || []).map(function (option, i) {
      return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        key: i,
        value: option.value
      }, option.label);
    })));
  }), !!NestedForm && NestedForm, !excludeButton && /*#__PURE__*/_react["default"].createElement(_core.Box, {
    mt: 4
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    disabled: !isValid || !!submitting || !!errorMessage,
    onClick: onSubmit,
    variant: "contained",
    color: "secondary"
  }, primaryButtonProps), buttonLabel), !!errorMessage && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    color: "error"
  }, errorMessage)));
};

exports["default"] = _default;